var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaperPlaneMemorySvg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#0D111D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2448_12321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0039 63.9678C17.652 63.9678 17.3001 63.8336 17.0317 63.5651C16.4947 63.0281 16.4947 62.1575 17.0317 61.6204L29.3762 49.2758C29.9132 48.7388 30.7838 48.7388 31.3208 49.2758C31.8579 49.8128 31.8579 50.6834 31.3208 51.2204L18.9762 63.5651C18.7077 63.8336 18.3559 63.9678 18.0039 63.9678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2861 49.2441L17 63.53C17.0104 63.5411 17.0196 63.5528 17.0304 63.5637C17.2989 63.8322 17.6509 63.9664 18.0027 63.9664C18.3546 63.9664 18.7066 63.8322 18.9751 63.5637L31.3196 51.219C31.8566 50.682 31.8566 49.8114 31.3196 49.2744C31.3088 49.2637 31.2971 49.2544 31.2861 49.2441Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8379 63.967C27.486 63.967 27.1341 63.8327 26.8657 63.5642C26.3286 63.0272 26.3286 62.1566 26.8657 61.6196L35.2094 53.2758C35.7464 52.7388 36.6171 52.7388 37.1541 53.2758C37.6911 53.8128 37.6911 54.6834 37.1541 55.2204L28.8103 63.5642C28.5417 63.8327 28.1899 63.967 27.8379 63.967Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.875 54.259C17.5231 54.259 17.1712 54.1248 16.9028 53.8563C16.3657 53.3193 16.3657 52.4487 16.9028 51.9116L25.3743 43.4399C25.9113 42.9029 26.782 42.9029 27.319 43.4399C27.856 43.9769 27.856 44.8475 27.319 45.3845L18.8474 53.8563C18.5789 54.1247 18.227 54.259 17.875 54.259Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.098 17.4341C62.7488 17.0849 62.2392 16.9497 61.7628 17.08L23.2817 27.6098C22.748 27.7559 22.3539 28.2075 22.2814 28.756C22.2089 29.3045 22.4722 29.843 22.9495 30.1227L35.1601 36.896L43.636 45.3719L50.4094 57.5827C50.6582 58.0075 51.1121 58.2628 51.5954 58.2628C51.6552 58.2628 51.7156 58.2589 51.776 58.2509C52.3244 58.1785 52.7761 57.7843 52.9221 57.2506L63.4519 18.7694C63.5823 18.2929 63.4473 17.7832 63.098 17.4341Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0964 17.4336L39.3965 41.1334L43.6345 45.3714L50.4078 57.5822C50.6566 58.007 51.1105 58.2623 51.5939 58.2623C51.6537 58.2623 51.7141 58.2584 51.7745 58.2504C52.3229 58.178 52.7745 57.7838 52.9206 57.2501L63.4504 18.7689C63.5807 18.2925 63.4457 17.7828 63.0964 17.4336Z",
    fill: "#287F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0975 17.4336L35.1597 36.8955L32.8516 45.9801C32.7147 46.4601 32.8486 46.9767 33.2016 47.3296C33.463 47.5912 33.8143 47.7324 34.1739 47.7324C34.2997 47.7324 34.4267 47.7151 34.551 47.6796L43.6355 45.3713L63.0975 17.4336Z",
    fill: "#36BA5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2012 47.3295L33.2014 47.3296C33.4628 47.5912 33.8141 47.7325 34.1737 47.7325C34.2995 47.7325 34.4265 47.7152 34.5508 47.6797L43.6353 45.3714L63.0972 17.4336L63.097 17.4338L33.2012 47.3295Z",
    fill: "#266336"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2448_12321"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    fill: "white",
    transform: "translate(16.5 17)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlaneMemorySvg);
export default __webpack_public_path__ + "static/media/PaperPlaneMemorySvg.2ebbd24495bd3e7fc06c4d70f46f948b.svg";
export { ForwardRef as ReactComponent };